import { Property } from './types';

/**
 * Gets properties to display in the property dropdown
 * @param disabled - properties to display as disabled
 * @param hidden - properties to hide
 * @param restrictTo - properties to show, will take precedence over hidden properties
 * @returns a parsed array of Property
 */
export const getPropertiesForDropdown = ({
  hiddenPropertySections = [],
  disabled = [],
  hidden = [],
  restrictTo = [],
  properties = [],
  shouldRestrict = false,
}: {
  hiddenPropertySections?: string[];
  disabled?: string[];
  hidden?: string[];
  restrictTo?: string[];
  properties: Property[];
  shouldRestrict?: boolean;
}) => {
  const filteredProperties = properties.filter((x) => !hiddenPropertySections.includes(x?.text));

  return filteredProperties.reduce((acc: Property[], property) => {
    const { value = '' } = property;
    const isPropertyAllowed = shouldRestrict
      ? restrictTo?.includes(value)
      : !hidden?.includes(value);

    if (isPropertyAllowed) {
      return [
        ...acc,
        {
          ...property,
          ...(disabled?.includes(value) ? { disabled: true } : {}),
        },
      ];
    }
    return acc;
  }, []);
};
